import { api } from './api';

export interface DashboardMetrics {
  active_strategies: number;
  total_clients: number;
  completed_briefs: number;
  generated_modules: number;
  strategies_change: number;
  clients_change: number;
  completed_change: number;
  modules_change: number;
}

export interface ActivityItem {
  id: string;
  action: string;
  client_name: string;
  module_name: string;
  created_at: string;
}

export interface StrategyProgressItem {
  strategy_id: string;
  client_name: string;
  progress: number;
  current_module: string;
  status: string;
}

export interface DashboardData {
  metrics: DashboardMetrics;
  recent_activities: ActivityItem[];
  strategy_progress: StrategyProgressItem[];
}

export const dashboardService = {
  async getDashboard(): Promise<DashboardData> {
    const response = await api.get('/dashboard');
    return response.data;
  },
};
